import JSON5 from 'process-js-objects'
import { dispatchCustomEventGlobally } from 'www/utils'
import { getScheduleElements } from 'www/vue_components/common/LpuServices/functions'
import { SCHEDULE_EVENTS } from 'www/modules/Schedule/constants'
import isHtmlElement from 'www/doctors.blocks/common/b-lpu-services/functions/isHtmlElement'

/**
 * @description Пытается отрендерить слоты. true - если событие вызвано не целевым элементом, либо будет рендер слотов
 */
export default function renderSchedule(event: MouseEvent): boolean {
  if (event?.target && isHtmlElement(event.target)) {
    try {
      const pricePrgButton = event.target.closest('button.b-lpu-services__price')

      if (!pricePrgButton) {
        return true
      }

      const servicePriceDataJson = event.target.closest('[data-schedule-service-price]') // Узел с данными для запроса расписания
        ?.getAttribute('data-schedule-service-price')

      if (servicePriceDataJson) {
        const storage = JSON5.parse(servicePriceDataJson)
        const scheduleElements = getScheduleElements(event)

        if (scheduleElements) {
          event.preventDefault() // Предотвращение перехода на форму записи

          dispatchCustomEventGlobally(SCHEDULE_EVENTS.clickSynonymPrice, {
            ...storage,
            scheduleElements,
            isLpuPriceList: true,
          })

          return true
        }
      }
    } catch { /* Empty */ }
  }

  return false
}
